// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"327ca5ac","455":"9ead5fad","977":"b9bfb9c4"}[chunkId] + ".chunk.js";
};